'use client'

import { Button } from '@/components/ui/button'
import { DateUtil } from '@/lib/utils/date'
import * as Sentry from '@sentry/nextjs'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const t = useTranslations('global_error')
  const time = new Date().toISOString()
  const currentUrl =
    typeof window !== 'undefined' ? decodeURI(window.location.href) : ''

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className='flex h-[calc(100vh-200px)] w-screen items-center justify-center overflow-hidden'>
      <div className='text-center'>
        <h1 className='mb-6 text-2xl font-medium'>{t('error_title')}</h1>

        <Button
          onClick={() => {
            window.location.replace(`/`)
          }}
          variant='white'
        >
          {t('home')}
        </Button>

        <Button
          onClick={() => {
            reset()
          }}
          variant='outline-neutral'
        >
          {t('retry')}
        </Button>
        <p className='mt-8 text-xs text-neutral-700'>URL: {currentUrl}</p>
        <p className='text-xs text-neutral-700'>
          Time: {DateUtil.formatFull(time)}
        </p>
      </div>
    </div>
  )
}
